// 一个指令，当点击按钮的时候，发送日志协议
import { useStore } from '@/store';
const { user} = useStore();

export default {
  mounted(el, binding) {
    el.addEventListener('click', () => {
      // /h5/tx3/us/collect_log
      // 贰，天下3地址

      // 手游地址
      let data = new FormData();
      data.append('activity', import.meta.env.VITE_NAME);
      data.append('op_code', 'click_btn');
      data.append('details', JSON.stringify(binding.value));
      data.append('server_group', import.meta.env.VITE_TEAM == 'tx2' ? 2 : 1);
      if (user?.value.isLoggedIn) {
        console.log('已登录');
        data.append('account_id', user.value.userId);
        data.append('role_name', '');
        data.append('role_id', '');
      }
      data.append('h5user_id', window.figureCode);
      fetch(`${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log `, {
        method: 'POST',
        body: data,
      });
    });
  },
  unmounted(el) {
    el.removeEventListener('click', () => {});
  },
};
